<template>
  <div class="border">
    <h4>Торговые точки</h4>
    <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
      :isAdd="true" :itemLink="itemLink" title_add="Добавить" :setLink="setLink" :openItem="false" :fields="fields"
      :params="params" :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  props: ['id'],
  created() {
    this.itemLink += `/${this.id}/shops`;
    this.setLink += `/${this.id}/shops`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: ' col-12 col-md-12',
          key: "shops",
          label: "Выберите  Торговые точки",
          type: "selects",
          modal: 'shop',
          selectKey: 'name'
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_field",
      itemLink: "organizations",
      setLink: "organizations",
      columns: [
        {
          key: "name",
          title: "Магазин",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          // detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
